/*
 * Wyszukiwanie produktów (lupa w nagłówku i strona /search), 21.10.2026.
 * Wyniki z listy produktów sklepu (/products.json), nie z wyszukiwarki Shopify:
 * tylko produkty, które mają wpisane słowa (także początek słowa w trakcie pisania),
 * kolejność: tytuł + dostępne, tytuł + wyprzedane, opis + dostępne, opis + wyprzedane.
 * Bez JavaScriptu działa dalej zwykła wyszukiwarka Shopify.
 */
(function () {
  var KLUCZ = 'szukajProduktow.v1';
  var WAZNOSC = 10 * 60 * 1000;
  var lista = null;

  function norm(s) {
    return (s || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&[a-z#0-9]+;/gi, ' ')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l')
      .replace(/\s+/g, ' ');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  function cena(kwota) {
    var n = parseFloat(kwota);
    if (isNaN(n)) return '';
    var s = Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2).replace('.', ',');
    var wzor = (window.theme && window.theme.moneyFormat) || '{{amount}} zł';
    return wzor.replace(/\{\{\s*[a-z_]+\s*\}\}/, s);
  }

  function uprosc(p) {
    var warianty = p.variants || [];
    var ceny = warianty.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
    var najtanszy = warianty.reduce(function (a, v) { return !a || parseFloat(v.price) < parseFloat(a.price) ? v : a; }, null);
    var zdj = (p.images || [])[0] || null;
    return {
      t: p.title,
      h: p.handle,
      nt: norm(p.title),
      nd: norm(p.body_html),
      d: warianty.some(function (v) { return v.available; }),
      c: ceny.length ? Math.min.apply(null, ceny) : null,
      cs: najtanszy && najtanszy.compare_at_price ? parseFloat(najtanszy.compare_at_price) : null,
      z: zdj ? zdj.src : null,
      zp: zdj && zdj.width && zdj.height ? zdj.width / zdj.height : 0.75
    };
  }

  function wczytaj() {
    if (lista) return Promise.resolve(lista);
    try {
      var zap = JSON.parse(sessionStorage.getItem(KLUCZ) || 'null');
      if (zap && Date.now() - zap.czas < WAZNOSC) {
        lista = zap.lista;
        return Promise.resolve(lista);
      }
    } catch (e) {}
    var root = (window.theme && window.theme.localeRootUrl) || '';
    var wszystkie = [];
    function strona(nr) {
      return fetch(root + '/products.json?limit=250&page=' + nr, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = j.products || [];
          wszystkie = wszystkie.concat(p.map(uprosc));
          return p.length === 250 && nr < 20 ? strona(nr + 1) : wszystkie;
        });
    }
    return strona(1).then(function (w) {
      lista = w;
      try { sessionStorage.setItem(KLUCZ, JSON.stringify({ czas: Date.now(), lista: w })); } catch (e) {}
      return w;
    });
  }

  function szukaj(zapytanie) {
    var slowa = norm(zapytanie).replace(/\*/g, ' ').split(' ').filter(Boolean);
    return wczytaj().then(function (w) {
      if (!slowa.length) return [];
      var wynik = [];
      w.forEach(function (p, i) {
        var tytul = slowa.every(function (s) { return p.nt.indexOf(s) !== -1; });
        var gdziekolwiek = tytul || slowa.every(function (s) { return p.nt.indexOf(s) !== -1 || p.nd.indexOf(s) !== -1; });
        if (!gdziekolwiek) return;
        var grupa = (tytul ? 0 : 2) + (p.d ? 0 : 1);
        // w grupie: tytuł zaczyna się od słowa, potem słowo na początku wyrazu, potem w środku wyrazu
        var trafienie = !tytul ? 0 : p.nt.indexOf(slowa[0]) === 0 ? 0 : (' ' + p.nt).indexOf(' ' + slowa[0]) !== -1 ? 1 : 2;
        wynik.push({ p: p, g: grupa, t: trafienie, i: i });
      });
      wynik.sort(function (a, b) { return a.g - b.g || a.t - b.t || a.i - b.i; });
      return wynik.map(function (x) { return x.p; });
    });
  }

  function zdjecie(src, szer) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + szer;
  }

  function karta(p, etykiety) {
    var url = '/products/' + encodeURIComponent(p.h);
    // motyw chowa karty w siatce (.js .ProductList--grid .ProductItem) do swojej animacji, nasze pokazujemy od razu
    var html = '<div class="ProductItem" style="visibility: visible"><div class="ProductItem__Wrapper">';
    html += '<a href="' + url + '" class="ProductItem__ImageWrapper">';
    if (p.z) {
      html += '<div class="AspectRatio AspectRatio--tall" style="--aspect-ratio: ' + p.zp + '">'
        + '<img class="ProductItem__Image" loading="lazy" src="' + esc(zdjecie(p.z, 600)) + '"'
        + ' srcset="' + esc(zdjecie(p.z, 400)) + ' 400w, ' + esc(zdjecie(p.z, 600)) + ' 600w, ' + esc(zdjecie(p.z, 800)) + ' 800w"'
        + ' sizes="(max-width: 640px) 50vw, 25vw" alt="' + esc(p.t) + '"></div>';
    }
    html += '</a>';
    if (etykiety && !p.d) {
      html += '<div class="ProductItem__LabelList"><span class="ProductItem__Label ProductItem__Label--soldOut Heading Text--subdued">Wyprzedany</span></div>';
    }
    html += '<div class="ProductItem__Info ProductItem__Info--center"><h2 class="ProductItem__Title Heading"><a href="' + url + '">' + esc(p.t) + '</a></h2>';
    if (p.c !== null) {
      html += '<div class="ProductItem__PriceList Heading">';
      if (p.cs && p.cs > p.c) {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + esc(cena(p.c)) + '</span> '
          + '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' + esc(cena(p.cs)) + '</span>';
      } else {
        html += '<span class="ProductItem__Price Price Text--subdued">' + esc(cena(p.c)) + '</span>';
      }
      html += '</div>';
    }
    html += '</div></div></div>';
    return html;
  }

  // lupa w nagłówku: ten sam układ co templates/search.ajax.liquid (kolumna produktów)
  function ajax(zapytanie) {
    return szukaj(zapytanie).then(function (w) {
      var ile = window.theme && window.theme.searchMode === 'product' ? 4 : 3;
      var html = '<div class="Segment"><div class="Segment__Title Segment__Title--flexed">'
        + '<span class="Heading Text--subdued u-h7">' + w.length + ' - liczba wyników</span>';
      if (w.length) {
        html += '<a class="Heading Link Link--secondary u-h7" href="/search?q=' + encodeURIComponent(zapytanie) + '&type=product">Zobacz wszystko</a>';
      }
      html += '</div><div class="Segment__Content">';
      if (!w.length) {
        html += '<p>Brak wyników</p>';
      } else {
        html += '<div class="Grid Grid--xl">';
        w.slice(0, ile).forEach(function (p) {
          html += '<div class="Grid__Cell 1/' + ile + '--tablet-and-up" onclick="window.location.href = \'/products/' + encodeURIComponent(p.h) + '\'">' + karta(p, false) + '</div>';
        });
        html += '</div>';
      }
      html += '</div></div>';
      return { text: function () { return Promise.resolve(html); } };
    });
  }

  // strona /search?q=...&type=product: wszystkie wyniki na jednej stronie
  function stronaWynikow() {
    var sekcja = document.querySelector('[data-szukaj-produktow]');
    if (!sekcja) return;
    var typy = sekcja.getAttribute('data-szukaj-typy') || '';
    if (typy.indexOf('product') === -1) return;
    var zapytanie = sekcja.getAttribute('data-szukaj-produktow');
    if (!zapytanie) return;
    szukaj(zapytanie).then(function (w) {
      var html = '<header class="PageHeader"><div class="Container"><div class="SectionHeader SectionHeader--center">'
        + '<h1 class="SectionHeader__Heading Heading u-h1">Wyszukiwanie</h1>'
        + '<div class="SectionHeader__Description">Znaleziono ' + w.length + ' wyniki(-ów) dla &quot;' + esc(zapytanie) + '&quot;</div>'
        + '</div></div></header>';
      if (w.length) {
        html += '<div class="ProductList ProductList--grid Grid" data-mobile-count="2" data-desktop-count="4">';
        w.forEach(function (p) { html += '<div class="Grid__Cell 1/2 1/3--tablet 1/4--lap-and-up">' + karta(p, true) + '</div>'; });
        html += '</div>';
      } else {
        html += '<div class="EmptyState"><div class="Container"><p>Brak produktów dla &quot;' + esc(zapytanie) + '&quot;</p></div></div>';
      }
      sekcja.innerHTML = html;
      // Shopify oddaje tę stronę raz z tytułem, raz z pustym, więc tytuł ustawiamy sami
      document.title = 'Wyszukiwanie: Znaleziono ' + w.length + ' wyniki(-ów) dla "' + zapytanie + '"';
    }).catch(function () {});
  }

  window.szukajProduktow = { ajax: ajax, szukaj: szukaj };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stronaWynikow);
  } else {
    stronaWynikow();
  }
})();
